import css from '../../../utils/css';

export default css`
  [class*='AccordionHeader'] {
    font-family: var(
      --widget-header-font-family,
      var(--widget-font-family, inherit)
    );
    font-size: var(--widget-header-font-size, 16px);
    font-weight: var(--widget-header-font-weight, 800);
    text-transform: var(--widget-header-text-transform);
  }

  [class*='MarketHeaderWrapper'] {
    border-bottom: 1px solid var(--widget-divider-color); /* widgets addition */
  }

  [class*='MarketHeaderWrapper'] > h4 {
    font-family: var(
      --widget-grid-header-font-family,
      var(--widget-font-family, inherit)
    );
    font-size: var(--widget-grid-header-font-size, 16px);
    font-weight: var(--widget-grid-header-font-weight, 400);
    text-transform: var(--widget-grid-header-text-transform);
  }

  [class*='BetContent']:not([class*='BetRowLeftBetContent']),
  [class*='ExpanderContent'] {
    background-color: var(--widget-background-color);
  }

  [class*='ShowMoreContainer'] {
    color: var(--widget-showmore-color, var(--widget-text-color));
  }

  [class*='ShowMoreContainer'] button {
    color: inherit;
    font-family: var(
      --widget-showmore-font-family,
      var(--widget-font-family, inherit)
    );
    font-size: var(--widget-showmore-font-size, 14px);
    font-weight: var(--widget-showmore-font-weight, 400);
  }

  [class*='ShowMoreContainer']::after {
    border-color: currentColor;
    color: inherit;
  }

  [class*='GridContentWrapper'] {
    color: var(--widget-text-color);
  }

  [class*='MarketExpanderBetWrapper'],
  [class*='BetBestOddsButtonWrapper'] {
    button {
      border-radius: var(--widget-best-odds-border-radius, 3px);
      border: var(--widget-best-odds-border-width, 0) solid
        var(--widget-best-odds-border-color, transparent);
      font-family: var(--widget-best-odds-font-family, inherit);
      font-size: var(--widget-best-odds-font-size, 15px);
      font-weight: var(--widget-best-odds-font-weight, 700);
    }
  }

  button[class*='GridToggler'] {
    background: var(--widget-grid-compare-bg-color);
    font-family: var(
      --widget-grid-compare-font-family,
      var(--widget-font-family, inherit)
    );
  }

  button[class*='GridToggler'][aria-expanded='true'] {
    color: var(
      --widget-grid-compare-active-color,
      var(--widget-text-color)
    ) !important;
  }

  button[class*='GridToggler'][aria-expanded='true'] > span[class^='Pointer_'] {
    background: var(
      --widget-grid-compare-active-bg-color,
      transparent
    ) !important;
  }

  #offer-portal .offer-item-wrapper {
    color: white;
  }

  #offer-portal [class*='OfferItemHeading_'],
  #offer-portal [class*='OfferItemDescription_'] {
    color: inherit;
  }

  [class*='OddsCellWrapper'] {
    border-radius: var(--widget-grid-odds-border-radius, 5px) !important;
  }

  [class*='OddsCellWrapper'] [class*='OddsCellBtn'] {
    border-radius: inherit;
    font-family: var(
      --widget-grid-odds-font-family,
      var(--widget-font-family, inherit)
    );
    font-size: var(--widget-grid-odds-font-size, 11px);
    font-weight: var(--widget-grid-odds-font-weight, normal);
  }

  [class*='OddsRow'] [class*='OddsCellMobile'] {
    border-radius: var(--widget-grid-odds-mobile-border-radius, 5px) !important;
    background-color: var(
      --widget-grid-odds-mobile-bg-color,
      #ececed
    ) !important;
    font-family: var(
      --widget-grid-odds-mobile-font-family,
      var(--widget-font-family, inherit)
    );
    font-size: var(--widget-grid-odds-mobile-font-size, 13px);
    font-weight: var(--widget-grid-odds-mobile-font-weight, 800);
    border-width: var(
      --widget-grid-odds-mobile-border-width,
      0 0 2px 0
    ) !important;
    border-color: var(
      --widget-grid-odds-mobile-border-color,
      #e0e0e0
    ) !important;
  }

  button[class*='OddsCellBtn'] {
    border: var(--widget-grid-odds-border-width, 1px) solid
      var(--widget-grid-odds-border-color, #e5e5e5) !important;
    color: var(--widget-grid-odds-text-color) !important;
    background-color: var(--widget-grid-odds-bg-color) !important;
  }

  button[class*='OddsCellBtn'][class*='bestOddsStyles'] {
    border: var(--widget-grid-best-odds-border-width, 2px) solid
      var(--widget-grid-best-odds-border-color) !important;
    color: var(--widget-grid-best-odds-text-color) !important;
    background-color: var(--widget-grid-best-odds-bg-color) !important;
    font-weight: var(--widget-grid-best-odds-font-weight, 800) !important;
  }

  [class*='OddsRow'] [class*='bestOddsStyles'] ~ [class*='OddsCellMobile'] {
    border-width: var(
      --widget-grid-best-odds-mobile-border-width,
      0 0 2px 0
    ) !important;
    border-color: var(
      --widget-grid-best-odds-mobile-border-color,
      #e0e0e0
    ) !important;
    color: var(--widget-grid-best-odds-mobile-text-color) !important;
    background-color: var(
      --widget-grid-best-odds-mobile-bg-color,
      #ececed
    ) !important;
    font-weight: var(
      --widget-grid-best-odds-mobile-font-weight,
      800
    ) !important;
  }

  [class*='BookmakersLabel_'] {
    font-family: var(
      --widget-bookies-label-font-family,
      var(--widget-font-family, inherit)
    );
    font-size: var(--widget-bookies-label-font-size, 12px);
    font-weight: var(--widget-bookies-label-font-weight, 800);
    text-transform: var(--widget-bookies-label-text-transform);
  }

  [class*='SeeAllOdds'] {
    font-family: var(
      --widget-mobile-seeall-font-family,
      var(--widget-font-family, inherit)
    );
    font-size: var(--widget-mobile-seeall-font-size, 12px);
    font-weight: var(--widget-mobile-seeall-font-weight, 400);
    text-transform: var(--widget-mobile-seeall-text-transform);
  }

  [class*='OddsHeadingWrapper'] [class*='oddsHeadingPart'] {
    font-family: var(
      --widget-bookies-label-font-family,
      var(--widget-font-family, inherit)
    );
    font-size: var(--widget-bookies-label-font-size, 11px);
    font-weight: var(--widget-bookies-label-font-weight, 400);
    text-transform: var(--widget-bookies-label-text-transform);
  }

  /* fix mobile offers badge colour */
  [class*='activeBtn'] [class*='OffersBadge'] {
    background: var(--widget-background-color);
    color: var(--widget-text-color);
  }
  /* fix mobile offers CTA */
  [class*='SeeOffersBtn'] {
    color: var(--widget-background-color);
  }
  /* fix mobile offers amount colour */
  [class*='OfferAmount'] {
    color: var(--widget-text-color);
  }

  /* Unsupported State Styles */
  [class*='OffersSection'][class*='not-supported'] {
    margin-top: 37px;
    padding-bottom: 0;
  }
  [class*='MarketWrapper'][class*='not-supported'] {
    --ogm-grid-cell-height-desktop: 42px;
    --widget-best-odds-width: 65px;

    [class*='MarketHeaderWrapper'] > h4 {
      font-weight: 800;
      color: black;
    }

    [class*='MarketExpanderBetWrapper'] button div {
      border: none;
    }

    [class*='BetBestOddsButtonWrapper'] button {
      border: 1px solid var(--ogm-disabled-grey);
      border-radius: 16px;
      font-size: 15px;
    }

    [class*='OddsCellWrapper'][class*='oddUnsupported'] {
      button[class*='OddsCellBtn'] {
        color: var(--ogm-disabled-grey) !important;

        &[class*='OddsCellDesktop'] {
          border-color: var(--ogm-disabled-grey) !important;
          border-radius: var(--widget-grid-odds-border-radius, 16px);
        }
      }
    }
    [class*='oddsAreaWrapper'] {
      [class*='OddsCellMobile'][class*='oddUnsupported'] {
        color: var(--ogm-disabled-grey) !important;
        border: 1px solid var(--ogm-disabled-grey) !important;
        background-color: transparent !important;
        border-radius: 16px !important;
        font-weight: bold !important;
      }
    }
  }
`;
